module.exports = "/_next/static/resources/photo-2-8abec682a8812ae1a0536e0f1012d637.jpg";